import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus } from "lucide-react";
import { faqData } from "../data/mock";

const FAQ = () => {
  const [openId, setOpenId] = useState(null);

  const toggle = (id) => setOpenId(openId === id ? null : id);

  return (
    <section id="faq" className="section relative overflow-hidden" style={{ background: "#0a0908" }}>
      <div className="container-xl relative z-10">
        <div className="grid lg:grid-cols-[1fr_1.5fr] gap-16">
          <div>
            <Kicker index="09" label="Common Inquiries" />
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9 }}
              className="mt-6 font-display text-[clamp(36px,4.5vw,64px)] leading-[1.1] text-[var(--cream)]"
            >
              Curiosity <br />
              meets <span className="italic gold-text">clarity.</span>
            </motion.h2>
            <p className="mt-6 text-[15px] text-[var(--cream-muted)] leading-relaxed max-w-sm">
              Everything you need to know about our craft, our process, and how we can tell your story.
            </p>
          </div>

          <div className="space-y-4">
            {faqData.map((faq, i) => (
              <motion.div
                key={faq.id}
                initial={{ opacity: 0, x: 20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.1 }}
                className="group border-b border-[rgba(201,169,97,0.15)] last:border-0"
              >
                <button
                  onClick={() => toggle(faq.id)}
                  className="w-full py-6 flex items-center justify-between text-left group"
                >
                  <span className={`font-display text-xl md:text-2xl transition-colors duration-300 ${openId === faq.id ? "text-[var(--gold)]" : "text-[var(--cream)] group-hover:text-[var(--gold)]"}`}>
                    {faq.question}
                  </span>
                  <div className={`w-8 h-8 rounded-full border border-[rgba(201,169,97,0.3)] flex items-center justify-center transition-all duration-300 ${openId === faq.id ? "bg-[var(--gold)] border-[var(--gold)]" : "group-hover:border-[var(--gold)]"}`}>
                    {openId === faq.id ? (
                      <Minus size={16} color="var(--ink)" />
                    ) : (
                      <Plus size={16} color="var(--gold)" className="group-hover:text-[var(--gold)]" />
                    )}
                  </div>
                </button>

                <AnimatePresence>
                  {openId === faq.id && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                      className="overflow-hidden"
                    >
                      <p className="pb-8 text-[15px] leading-relaxed text-[var(--cream-muted)] max-w-2xl">
                        {faq.answer}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

const Kicker = ({ index, label }) => (
  <div className="flex items-center gap-4">
    <span className="font-impact text-[11px] tracking-[0.4em] text-[var(--gold)]">{index}</span>
    <span className="w-16 h-px bg-[var(--rule)]" />
    <span className="font-impact text-[11px] tracking-[0.4em] text-[var(--cream-muted)]">{label.toUpperCase()}</span>
  </div>
);

export default FAQ;
